import { createAction } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";

import {
	AssessmentsFilter,
	CustomerAssessments,
	CustomerAssessmentsModel,
	CustomerAssessmentsResponse,
} from "./customer-assessments.model";

/**
 * @deprecated [fabric-deprecated] - Use CustomerAssessmentService from app-account instead
 */
export namespace CustomerAssessmentsAction {
	const ACTION_PREFIX = "[Customer Assessments]";

	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppCommand.SubmitAnswers instead
	 */
	export const submitAnswers = createAction(
		`${ACTION_PREFIX} Submit Answers`,
		(model: CustomerAssessmentsModel, assessmentId: string) => ({ model, assessmentId })
	);
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppCommand.SubmitAnswers instead
	 */
	export const submitAnswersSuccess = createAction(`${ACTION_PREFIX} Submit Answers Success`);
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppCommand.SubmitAnswers instead
	 */
	export const submitAnswersFail = createAction(`${ACTION_PREFIX} Submit Answers Fail`, (error: AppError) => ({
		error,
	}));
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppValue.GetAssessment instead
	 */
	export const getAssessment = createAction(`${ACTION_PREFIX} Get Assessment`, (assessmentId: string) => ({
		assessmentId,
	}));
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppValue.GetAssessment instead
	 */
	export const getAssessmentSuccess = createAction(
		`${ACTION_PREFIX} Get Assessment Success`,
		(model: CustomerAssessmentsResponse) => ({ model })
	);
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppValue.GetAssessment instead
	 */
	export const getAssessmentFail = createAction(`${ACTION_PREFIX} Get Assessment Fail`, (error: AppError) => ({
		error,
	}));
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppValue.GetCustomerAssessments instead
	 */
	export const getCustomerAssessments = createAction(
		`${ACTION_PREFIX} Get Customer Assessments`,
		(params: AssessmentsFilter = {}) => ({ params })
	);
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppValue.GetCustomerAssessments instead
	 */
	export const getCustomerAssessmentsSuccess = createAction(
		`${ACTION_PREFIX} Get Customer Assessments Success`,
		(assessments: CustomerAssessments[]) => ({ assessments })
	);
	/**
	 * @deprecated [fabric-deprecated] - Use AccountAppValue.GetCustomerAssessments instead
	 */
	export const getCustomerAssessmentsFail = createAction(
		`${ACTION_PREFIX} Get Customer Assessments Fail`,
		(error: AppError) => ({ error })
	);
}
